import axios from 'axios';

export const handlePdfExtraction = async (file) => {
  const formData = new FormData();
  formData.append('pdf', file);

  try {
    const response = await axios.post('https://pdf-extractor-api-blond.vercel.app/pdf/extract', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    // Format the data
    const formattedData = formatPdfData(response.data);
    return formattedData;
  } catch (error) {
    console.error('Error extracting PDF data:', error);
    throw error;
  }
};

const formatPdfData = (pdfData) => {
  // Ensure pdfData is an array
  const dataArray = Array.isArray(pdfData) ? pdfData : [pdfData];

  return dataArray
    .filter(item => item.orderId && item.orderId.trim() !== '')
    .map(item => ({
      "Id": item.orderId,
      "Balance": item.value,
      "Amount": item.realisedPL,
      "Currency": item.instrumentCurrency,
      "Type": "TRADE",
      "Status": "PROCESSED",
      "Modified": item.executionTime,
      "Trade Id": item.orderId,
      "Instrument Symbol": item.instrument,
      "Instrument Name": item.instrument,
      "Commission": item.fxFee,
      "Account type": "T212"
    }));
};